import request from "@/utils/request";

export const zhonganApply = data =>
  request({ url: "/api/core/zhongan_deduction_apply", method: "post", data });
